function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.23 24c-.47-5.13 3.05-5.38 5.59-6.46s5-1.89 7.54-2.82c-.08-.49-.15-1-.23-1.46-5-.15-10.06-.58-15.07-.38C28 13.35 16 14.09 3.9 14.8.23 15-.47 13.28.26 10.72l61.53-.33-11.58-8.65L51.47 0c2.24 1.33 4.45 2.72 6.74 4s5 3.76 7.42 3.62c5.8-.33 6.47 2.36 5.6 7.12l-29 9.26",
  "data-name": "Layer 1"
}));

function SvgTimelineArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 71.54 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA3MS41NCAyNCI+PHRpdGxlPkFzc2V0IDE8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggZD0iTTQyLjIzLDI0Yy0uNDctNS4xMywzLjA1LTUuMzgsNS41OS02LjQ2czUtMS44OSw3LjU0LTIuODJjLS4wOC0uNDktLjE1LTEtLjIzLTEuNDYtNS0uMTUtMTAuMDYtLjU4LTE1LjA3LS4zOEMyOCwxMy4zNSwxNiwxNC4wOSwzLjksMTQuOC4yMywxNS0uNDcsMTMuMjguMjYsMTAuNzJsNjEuNTMtLjMzTDUwLjIxLDEuNzQsNTEuNDcsMGMyLjI0LDEuMzMsNC40NSwyLjcyLDYuNzQsNHM1LDMuNzYsNy40MiwzLjYyYzUuOC0uMzMsNi40NywyLjM2LDUuNiw3LjEyTDQyLjIzLDI0Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgTimelineArrow as ReactComponent };